import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

import Concertina from "../../../components/Concertina";
import ResultItem, { IResult } from "../Result";

export interface IRelatedArticle {
  id: string;
  title: string;
  item: IResult;
  settings: any;
  tabId: string;
}

const RelatedArticle: FunctionComponent<IRelatedArticle> = ({ item, settings, title, id, tabId }) => {
  const { relatedDocument } = item;
  return (
    <Concertina
      title={"Related documents"}
      id={title.replace(/\s+/g, "")}
      isRichtext={false}
      isCompact={true}
      isOpenByDefault={false}
      isRelatedDocuments={true}
      className="related-results"
    >
      <ol className="related-results__list">
        {relatedDocument &&
          relatedDocument.map((relItem, i) => {
            return (
              <li
                key={i}
                className="related-results__item"
              >
                <ResultItem
                  item={relItem}
                  id={`related-item-${id}-${i}`}
                  title={relItem.title}
                  settings={settings}
                  includeRelated={false}
                  tabId={tabId}
                />
              </li>
            );
          })}
      </ol>
    </Concertina>
  );
};

export default RelatedArticle;
